export default __webpack_public_path__ + "static/media/lr_arrows.a9c8a6ae.svg";